module.exports = __webpack_public_path__ + "static/media/shiftThePower.518c317c.png";